import { useMemo } from "react"
import type { MeetingInspirePanel as MeetingInspirePanelInfo } from "services/api/meetingsClient"
import type { InspireControlAction } from "../../inspireControlMessages"
import MeetingInspirePanel from "../../MeetingInspirePanel"
import type { InspireEmbedContext } from "../types"
import { getPanelTokenFromUrl } from "../shared/panelUrls"

type InspireStageProps = {
  meetingId: string
  panel: MeetingInspirePanelInfo
  onControlAction: (action: InspireControlAction, activityId: string) => Promise<boolean>
  refreshKey?: number
  /** Puts the card back in the Inspire tab for this attendee only. */
  onHide?: () => void
}

/**
 * A live Inspire Card on the call stage, the way the legacy Prebuilt call showed the card as a
 * "main" integration: the card and response view fill the stage while every camera sits in the
 * thumbnail rail. Presenters keep their controls in the Inspire tab and see the same card view here.
 */
export function InspireStage({ meetingId, panel, onControlAction, refreshKey }: InspireStageProps) {
  const panelToken = useMemo(() => getPanelTokenFromUrl(panel.url), [panel.url])
  const embed = useMemo<InspireEmbedContext>(() => ({ meetingId, panelToken, onControlAction, refreshKey }), [meetingId, onControlAction, panelToken, refreshKey])
  if (!panelToken) return null
  return (
    <section aria-label="Inspire Card" data-testid="call-inspire-stage" data-inspire-role={panel.role} className="relative h-full w-full">
      <MeetingInspirePanel embed={embed} />
    </section>
  )
}
